<template>
  <div class="main">
    <div class="left">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="flex-container"
        label-position="top"
        width="150px"
        size="large"
      >
        <el-form-item class="flex-item" label="Enter target gene list. (Maize)">
          <el-input
            type="textarea"
            :rows="13"
            placeholder="Please enter Gene ID"
            v-model="form.data"
          >
          </el-input>
          <el-button
            @click="updataExample"
            plain
            style="margin-top: 10px; margin-bottom: 10px"
          >
            Example
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <el-popover
            placement="bottom"
            width="500"
            trigger="hover"
            :open-delay="100"
          >
            <h2 style="text-align: center; margin: 0 auto">Right example</h2>
            <el-input
              type="textarea"
              style="width: 95%; margin: 10px"
              :value="exampleSeq"
              rows="10"
              :readonly="true"
            />
            <el-button
              slot="reference"
              style="margin-left: 20px"
              class="el-icon-info"
              ref="dataBu"
            >
              First : Correct data format</el-button
            >
          </el-popover>
        </el-form-item>
        <el-form-item class="flex-item" label="Or upload file">
          <el-upload
            class="upload-demo"
            style="width: 600px"
            ref="upload"
            action=""
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :auto-upload="false"
            :limit="1"
            drag
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop files here, Or <em>Click Upload</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
          </el-upload>
          <!-- <el-button :loading="loading" @click="submitFile" plain size="large"
            >Upload File</el-button
          > -->
        </el-form-item>
        <el-form-item
          prop="email"
          class="email-full-width"
          label="Please enter your email address"
          style="width: 100%"
        >
          <el-input
            v-model="form.email"
            style="width: 400px"
            placeholder="example@example.com"
          ></el-input>
          <el-button
            @click="submitDataFile"
            :loading="loading"
            plain
            style="margin-top: 10px; margin-bottom: 10px; margin-left: 20px"
          >
            Submit
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="!isPdfLoading" class="right">
      <el-tabs type="border-card" style="height: 100%">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> Image</span>
          <iframe
            :src="pdfUrl"
            style="width: 100%; height: 1200px"
            frameborder="0"
          >
          </iframe>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        data: "",
        email: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "Please enter your email address",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
        // 其他验证规则...
      },
      loading: false,
      isPdfLoading: true, // 新增PDF加载状态标识
      pdfPlaceholder: "path-to-your-placeholder-image.png", // 占位图路径
      file: null,
      fileId: null,
      pdfUrl: "",
      exampleSeq: `100276168
100382679
100382719
100500945
100502483
103627864
103629097
103629405
103633374
103648261
103649559
103649948
103650610
103651081
103651189
103651302
103651344
103651359
103651607
103651681
103652395
103652674
103653497
103654862
100192474
541623
541868
541886
541912
541927
542002
542102
542270
542385
542432
542438
542459
542483
542498
542520
542583
542663
542694
542709
542759
606485
100383421
732834
732845
100037774
100037782
100125654
100125661
100191167
100191168
100191234
100191277
100191409
100191447
100191448
100191501
100191618
100191628
100191664
100191667
100191711
100191714
100191715
100191823
100191825
100191868
100191933
100191935
100191956
100192017
100192080
100192090
100192540
100192554
100192567
100192628
100192728
100192761
100192787
100192824
100192833
100192870
100192967
100192978
100193037
100193086
100193108
100193157
100193196
100193239
100193258
100193269
100193331
100193357
100193499
100193526
100193541
100193565
100193614
100193630
100193671
100193856
100193860
100193895
100194098
100194113
100194115
100194130
100194135
100194159
100194169
100194194
100194249
100194285
100194319
100194350
100194401
100216562
100216635
100216655
100216665
100216690
100216751
100216811
100216860
100216902
100216960
100216961
100216962
100216974
100216981
100216985
100217005
100217015
100217038
100217072
100217094
100217099
100217158
100217186
100272274
100272312
100272321
100272341
100272349
100272424
100272432
100272521
100272564
100272593
100272644
100272684
100272690
100272692
100272860
100272916
100272945
100272959
100273040
100273174
100273241
100273269
100273313
100273428
100273458
100273493
100273563
100273564
100273641
100273698
100273833
100273886
100273889
100273911
100273916
100273958
100274169
100274174
100274186
100274190
100274205
100274208
100274254
100274288
100274290
100274583
100274593
100274599
100274616
100274652
100277165
100274734
100274762
100274799
100274833
100274850
100274915
100275038
100275082
100275086
100275095
100275129
100275361
100275367
100275455
100275554
100275569
100275611
100275797
100275828
100276124
100276149
100276210
100276230
100276440
100276561
100276591
100276603
100276613
100276684
100276794
100276850
100276872
100276893
100276919
100276942
100277044
100277144
100277171
100277518
100277613
100277741
100277804
100277806
100277858
100277943
100277987
100277999
100274798
100278172
100278181
100278182
100278234
100278335
100278465
103629633
100278588
100278702
100278787
100278798
100278802
100303840
100279181
100279202
100279266
100279267
100279296
100279331
100279407
100279455
100279608
100279711
100279734
100279749
100279785
100279794
100279801
100279844
100279884
100279912
100280029
100280079
100280155
100280209
100280263
100280276
100280296
100280384
100280405
100280419
100280442
100280455
100280491
100280514
100280557
100280678
100280714
100280717
100280724
100280751
100280752
100280784
100382495
100280902
100280943
100280972
100281036
100281038
100281077
100281085
100281099
100281102
100281145
100281214
100280060
100281371
100217023
100281385
100281414
100281416
100281502
100281519
100281591
100281621
100281724
100281785
100281818
100281866
100281926
100281927
100282000
100282008
100282031
100282076
100282093
100282099
100282106
100282130
100282194
100282229
100282247
100282269
100282421
100282436
100282477
100282505
100282512
100282555
100282570
100282642
100282672
100282711
100282717
100282732
100282761
100282894
100282967
100283015
100283035
100283086
100283087
100283088
100283121
100283137
100283272
100283296
100283318
100283324
100283348
100283420
100283429
100283498
100283511
100283522
100283604
100283620
100283631
100283695
100283705
100283714
100283730
100283731
100283762
100283782
100283871
100283921
100283964
100283974
100283985
100283988
100284024
100284039
100284064
100284261
100284358
100284550
103641961
100284620
100284675
100284730
100284748
100284784
100284821
100284851
100284875
100284897
100284957
100285044
100285073
100285076
100285081
100285204
100285211
100285350
100285361
100285436
100285443
100285522
100285524
100285566
100285622
100285641
100285678
100285705
100285710
100285721
100285743
100285839
100285906
100285947
100285975
100285999
100286006
100286027
100286045
100286054
100286064
100286078
100286086
100286215
100286244
100286290
100286852
100303995
100304252
100304315
100304335
100304348
100304398
100274428
100381578
100381604
100381620
100381660
100381737
100381814
100381911
100382024
100382050
100382075
100382185
100382206
100382282
100382342
100382347
100382368
100382369
100382374
103649505
100382503
100382689
100382718
100383048
100383110
100383130
100383171
100383396
100383421
100383492
100383513
100383551
100383617
100383738
100383875
100383938
100383962
100384054
100384181
100384251
100384259
100384688
100384795
100384825
100501213
100501234
100501403
100501708
100501715
100501751
100501773
100501876
100501883
100502153
100502156
100502230
100502381
100502407
100502510
100533160
100856957
100857065
101027121
101027228
101202696
103625710
103625711
103625721
103625761
103625788
103625889
103625915
103626085
103626094
103626119
103626457
103626486
103626490
103626509
103626570
103626588
103626750
103627036
103627205
103627303
103627318
103627401
103627461
103627500
103627568
103627642
103627673
103627759
103627794
103627842
103627849
103627873
103627905
103627969
103628908
103629018
103629070
103629223
103629710
103629780
103629894
103629936
103630076
103630424
103630425
103630444
103630489
103630501
103630558
103630600
103630656
103630662
103630680
103631174
103631177
103631366
103631565
103631601
103631683
103631743
103631752
103631754
103631781
103631836
103631912
103632001
103632029
103632710
103633058
103633120
103633128
103633213
103633218
103633227
103633382
103633402
103633430
103633493
103633545
103633605
103634339
103634415
103634483
103634500
103634503
103634581
103634689
103634712
103634857
103635020
103635303
103635349
103635416
103635801
103635903
103635959
103635983
103636094
103636115
103636117
103636194
103636202
103636208
103636230
103636232
103636245
103636309
103636402
103636459
103636490
103636515
103636516
103636579
103636597
103636607
103636665
103636708
103636717
103637353
103637972
103638036
103638155
103638192
103638194
103638235
103638767
103638807
103638882
103639173
103639276
103639290
103639302
103639399
103639539
103639559
103639614
103639735
103639800
103639887
103640187
103640638
103640844
103641020
103641135
103641240
103641250
103641296
103641301
103641321
103641627
103641797
103641890
103641910
103642006
103642101
103642146
103642148
103642186
103642258
103642259
103642272
103642347
103642376
103643044
103643192
109942132
103643638
103643715
103643754
103643766
103643900
103644012
103644136
103644166
103644212
103644281
103644628
103645145
103645239
103645747
103645756
103645840
103645874
103645937
103645953
103645982
103645983
103646047
103646089
103646268
103646270
103646291
103646515
103647285
103647355
103647414
103647458
103647523
103647615
103647690
103647736
103647839
103647921
103647983
103648067
103648178
103648264
103648285
103648992
103649220
103649976
103650037
103650094
103650267
103651237
103651710
103652170
103652237
103652452
103652697
103652884
103653233
103653843
103653865
103653931
103653945
103654002
103654181
103654232
103654967
103655794
103656008
107275232
109939177
109939362
109939586
109940235
109940370
109940593
109940774
109940924
109941327
109941411
109941606
109941652
109943024
109943071
103645794
109944102
109946042
110017798
100279366
100276310
100282390
100283109
100284989
100381927
100382040
100284749
100193721`,
    };
  },
  created() {
    if (this.$route.query.modelName === "go") {
      if (this.$route.query.taskID) {
        console.log(this.$route.query);
        this.pdfUrl =
          `http://124.220.197.196:8084/images/result/` +
          this.$route.query.taskID +
          ".pdf";
        console.log(this.pdfUrl);
        this.isPdfLoading = false;
        this.$message.success("File uploaded successfully");
      } else {
        this.$message.error("TaskId Error");
      }
    }
  },
  methods: {
    submitDataFile() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.file) {
            this.submitFile();
          } else if (this.form.data) {
            this.submitData();
          } else {
            this.$message.error("Please select a file or enter data");
          }
        } else {
          // alert("表单验证失败!");
          return false;
        }
      });
    },
    async submitFile() {
      if (!this.file) {
        this.$message.error("Please select a file");
        return;
      }
      // let formData = new FormData();
      // formData.append("file", this.file); // 'file' 是你后端接口期待的字段名
      let form = {
        file: this.file,
        email: this.form.email,
        project: "go",
        modelName: "go",
      };
      this.loading = true;
      this.isPdfLoading = true; // 开始请求时设置加载状态为true
      this.$router.push("/search");

      try {
        // 注意：这里的URL应该改为你的实际后端接口URL
        let result = await this.$API.resSubmitGoFile(form);
        console.log(result);
        this.fileId = result.taskId;
        this.pdfUrl =
          `http://124.220.197.196:8084/images/result/` + this.fileId + ".pdf";
        this.isPdfLoading = false;
        this.$message.success("File uploaded successfully");
      } catch (error) {
        this.$message.error("File upload failed");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleFileChange(file) {
      this.file = file.raw;
    },
    handleFileRemove(file) {
      this.file = null;
    },
    updataExample() {
      this.form.data = this.exampleSeq;
    },
    async submitData() {
      if (!this.form.data) {
        this.$message.error("Please enter data");
        return;
      }
      this.loading = true;
      this.isPdfLoading = true; // 开始请求时设置加载状态为true
      let params = {
        rdata: this.form.data,
        email: this.form.email,
        project: "go",
        modelName: "go",
      };
      this.$router.push("/search");

      try {
        let result = await this.$API.resSubmitData(params);
        console.log(result);
        this.fileId = result.taskId;
        this.pdfUrl =
          `http://124.220.197.196:8084/images/result/` + this.fileId + ".pdf";
        this.isPdfLoading = false;
        this.$message.success("文件上传成功。");
      } catch {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.main {
  min-height: 750px;
  display: flex;
  flex-direction: column; // 设置flex方向为列
  align-items: center; // 可以根据需求调整子元素的水平对齐方式
  padding-top: 50px;
  padding-bottom: 50px;
  background-image: url("../../assets/picture/schoolBack.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;

  .left {
    border: 1.5px solid #00712f;
    border-radius: 2%;
    background-color: #fff;
    width: 80%; // 可调整宽度以适应屏幕
    margin: 20px; // 调整外边距以适应上下布局
    padding: 10px 20px;
    .flex-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between; /* 这会在两个表单项之间添加空间 */
      .flex-item {
        flex: 1; /* 两个元素平分空间 */
        margin-right: 10px; /* 或根据需要调整间隔 */
        font-size: 22px !important;
      }
      /* 如果你希望第一个表单项更宽，可以给它一个更大的flex值 */
      .flex-item:first-child {
        flex: 1; /* 使第一个元素比第二个元素宽一些 */
      }
      .flex-item:nth-child(2) {
        margin-left: 20px;
      }

      .email-full-width {
        width: 100%; /* 使该表单项占据全宽 */
      }
    }
  }

  .right {
    // border: 1px solid;
    width: 80%; // 可调整宽度以适应屏幕
    margin: 20px;
  }
}
</style>

<style lang="less">
/* 其余的样式 */

.el-form-item__label {
  font-size: 18px !important; /* 调整字体大小并确保它覆盖其他样式 */
}

.el-upload-dragger {
  width: 100% !important;
  height: 288px;
}
.el-upload {
  width: 100% !important;
}
</style>
